import { SystemConfigResponse } from '@core/models/system-config.model';
import { AirportDDL } from '@models/airport.model';
import { DropDownListModel } from '@models/dropdown-list.model';
import { AirCraftDDL } from '@models/master-data.model';
import {
    CountryDialCode,
    InFlightServiceMap,
    MasterDataState,
    SharedData,
} from '@models/store.model';
import { createAction, props } from '@ngrx/store';

export const loadAfterInit = createAction('[LOAD] Load after init');
export const loadAirportDLLAction = createAction('[MasterData] Load Airport DLL');
export const loadAirlineLabelAction = createAction('[MasterData] Load Airline Label');
export const loadCountryDialCodeAction = createAction('[MasterData] Load country dial code action');
export const loadCountryDDLAction = createAction('[MasterData] Load country DDL action');
export const loadAirCraftDDLAction = createAction('[MasterData] Load Air craft DDL action');
export const loadInFlightServiceAction = createAction('[MasterData] Load in flight service action');

export const loadAirportDLLSuccessAction = createAction(
    '[MasterData] Load Airport DLL',
    props<{ data: Pick<MasterDataState, 'airportMaps' | 'airports'> }>()
);
export const loadDLLAction = createAction(
    '[MasterData] Load DLL',
    props<{
        dllName: keyof MasterDataState;
        data:
            | AirportDDL[]
            | Record<string, string>
            | Record<string, CountryDialCode>
            | CountryDialCode[]
            | DropDownListModel[]
            | Record<string, AirCraftDDL>
            | Record<string, InFlightServiceMap>;
    }>()
);

export const loadCountryDialCode = createAction(
    '[MasterData] Load country dial code',
    props<{
        array: CountryDialCode[];
        maps: Record<string, CountryDialCode>;
    }>()
);

export const setSharedData = createAction(
    '[MasterData] set shared data',
    props<{ data: SharedData | null }>()
);